import { createSlice } from '@reduxjs/toolkit';
import { addExtraReducer } from '../../utils/addExtraReducer';
import initialState from './initialState';
import { ClearTobaccoDryProductionsReducer, GetTobaccoDryProductionReducer } from './reducers';
import { GetTobaccoDryProduction } from './thunks';

// ----------------------------------------------------------------------------

// slice
export const slice = createSlice({
  name: 'tobaccoDryProduction',
  initialState,
  reducers: {
    ClearTobaccoDryProductions: ClearTobaccoDryProductionsReducer,
  },
  extraReducers: (builder) => {
    addExtraReducer(builder, GetTobaccoDryProduction, GetTobaccoDryProductionReducer);
  },
});

export default slice.reducer;
